var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1484,
    height: 181,
    viewBox: "0 0 1484 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.963 39.605L233.323 86.8832L219.149 39.605H194.517L180.342 86.8832L165.703 39.605H123.888C113.053 16.2082 89.9519 2.3334 57.3951 2.3334H0V145.344H57.3951C103.643 145.344 130.827 117.397 130.827 73.8342C130.827 70.8097 130.684 67.8571 130.424 64.9852L157.796 145.335H193.12L205.906 103.172L218.916 145.335H254.24L290.262 39.587H247.972L247.963 39.605ZM55.076 106.681H44.1522V40.7717H55.076C75.0614 40.7717 86.4509 53.5784 86.4509 73.8431C86.4509 94.1078 75.0614 106.681 55.076 106.681Z",
    fill: "url(#paint0_linear_2_140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.695 37.0382C302.484 37.0382 283.43 54.7362 280.636 76.4009H322.004C323.168 73.3765 325.952 70.8097 331.065 70.8097C337.575 70.8097 339.894 75.4675 339.894 79.892V85.7165C335.712 82.6921 325.72 80.1254 317.348 80.1254C294.81 80.1254 277.144 92.6988 277.144 113.43C277.144 136.253 294.802 147.202 315.02 147.202C325.944 147.202 336.402 143.711 339.885 140.21V145.335H382.64V82.9165C382.64 53.8028 364.517 37.0293 332.677 37.0293L332.695 37.0382ZM339.903 114.83C337.808 117.855 333.393 119.955 327.815 119.955C322.702 119.955 317.589 117.621 317.589 112.497C317.589 107.372 322.702 105.048 327.815 105.048C333.393 105.048 337.808 107.148 339.903 110.172V114.83Z",
    fill: "url(#paint1_linear_2_140)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M651.251 37.2716C624.219 37.2716 603.329 53.2913 597.841 78.7702V75.7098C597.841 52.1874 583.434 37.2805 560.422 37.2805C548.576 37.2805 538.108 41.705 532.306 48.2296V39.614H448.389L433.051 89.6923L417.015 39.614H371.466L410.272 139.771L394.468 181H438.155L488.145 49.3424V145.362H532.297V84.8011C533.694 79.4433 538.108 76.1855 543.454 76.1855C550.429 76.1855 553.679 81.31 553.679 87.6012V145.362H597.832V106.484C603.15 131.514 623.091 147.695 651.941 147.695C680.79 147.695 700.507 132.555 704.456 106.232H663.321C661.692 111.824 657.277 114.148 651.932 114.148C644.267 114.148 640.086 109.724 638.456 100.641H704.456V90.859C704.456 59.1786 685.169 37.2895 651.242 37.2895L651.251 37.2716ZM639.396 81.7587C641.259 75.0008 644.974 70.8097 651.251 70.8097C657.528 70.8097 661.244 75.4675 662.175 81.7587H639.405H639.396Z",
    fill: "url(#paint2_linear_2_140)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M834.871 99.4656H851.606C847.89 105.29 840.915 108.315 830.922 108.315C813.954 108.315 803.505 95.0412 803.505 73.8431C803.505 54.0451 812.799 39.3716 830.922 39.3716C840.915 39.3716 847.657 44.0294 850.442 52.1784H896.689C891.577 22.5981 869.729 0 830.922 0C787.701 0 758.189 30.5137 758.189 73.8341C758.189 117.155 787.701 147.668 830.922 147.668C870.66 147.668 896.922 122.979 896.922 83.3831V67.5429H834.871V99.4567V99.4656Z",
    fill: "url(#paint3_linear_2_140)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1135.38 10.0247H1091.92V39.605H1077.28V66.0352C1069.61 48.3104 1052.92 37.2806 1028.84 37.2806C1004.76 37.2806 985.979 49.7104 978.027 70.0828V39.1473C976.398 38.2139 973.148 37.2806 968.966 37.2806C958.042 37.2806 950.378 41.705 944.799 48.2296V39.614H900.647V145.362H944.799V87.1345C946.196 81.7767 952.007 77.8189 962 77.8189C967.283 77.8189 971.187 78.4471 975.207 79.9279C974.428 83.9037 974.016 88.0948 974.016 92.4924C974.016 125.33 995.631 147.695 1029.56 147.695C1058.37 147.695 1078.12 132.555 1082.07 106.233H1040.94C1039.31 111.824 1034.89 114.148 1029.55 114.148C1021.88 114.148 1017.69 109.724 1016.07 100.641H1082.07V90.859C1082.07 84.7114 1081.34 78.9407 1079.92 73.6188H1091.94V104.599C1091.94 134.413 1106.35 147.22 1134.93 147.22C1143.29 147.22 1152.13 146.053 1156.54 144.428V107.624C1153.29 108.557 1149.57 109.024 1145.85 109.024C1138.88 109.024 1135.39 105.533 1135.39 97.3746V73.6188H1156.54V39.614H1135.39V10.0247H1135.38ZM1016.99 81.7677C1018.85 75.0098 1022.56 70.8187 1028.84 70.8187C1035.12 70.8187 1038.83 75.4765 1039.77 81.7677H1017H1016.99Z",
    fill: "url(#paint4_linear_2_140)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.4 73.6098H1201.77L1160.4 115.306V145.353H1254.98V111.348H1215.71L1254.98 68.952V39.605H1160.4V73.6098Z",
    fill: "url(#paint5_linear_2_140)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.55 39.605L1425.21 89.6833L1409.17 39.605H1377.81H1363.62H1325.76L1302.98 68.2519V2.3334H1258.82V145.353H1302.98V116.706L1308.32 109.481L1328.77 145.353H1378.74L1340.63 82.6921L1368.02 50.9489L1402.43 139.762L1386.63 180.991H1430.32L1484 39.605H1440.55Z",
    fill: "url(#paint6_linear_2_140)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_140",
    x1: 145.131,
    y1: 2.3334,
    x2: 145.131,
    y2: 145.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_140",
    x1: 329.892,
    y1: 37.0293,
    x2: 329.892,
    y2: 147.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_140",
    x1: 537.961,
    y1: 37.2716,
    x2: 537.961,
    y2: 181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_140",
    x1: 827.555,
    y1: 0,
    x2: 827.555,
    y2: 147.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_140",
    x1: 1028.6,
    y1: 10.0247,
    x2: 1028.6,
    y2: 147.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_140",
    x1: 1207.69,
    y1: 39.605,
    x2: 1207.69,
    y2: 145.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_140",
    x1: 1371.41,
    y1: 2.3334,
    x2: 1371.41,
    y2: 180.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#EAD13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#E6965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36AC5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientLogo);
export default __webpack_public_path__ + "static/media/gradient_logo.c7483abff3bcbdc1fe3b6d7f2e5f5691.svg";
export { ForwardRef as ReactComponent };